import React, { useEffect, useRef, useState } from "react";
import "./EpisodeReview.css";
import EditAuditModal from "../EpisodeReview/EditAuditModal/EditAuditModal";
import {
  assignEpisodes,
  getCodeEnhanceWorkflowViewData,
  getEnhanceWorkflowEpisodeDetails,
  recallEpisodes,
  reflagCombinedReviewEpisodes,
  updateEpisodeStatus,
} from "../EnhanceWorkflow/EnhanceWorkflowSlice";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import UnassignReasonModal from "../UnassignModal/UnassignReasonModal";
import { GenerateCDQModal } from "../GenerateCDQModal/GenerateCDQModal";
import axiosInstance from "../../../../axiosinterceptor";
import AssignEpisodesDialog from "../../workflowActions/AssignEpisodesDialog";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FlagIcon from "@mui/icons-material/Flag";
import { getCombinedReviewData } from "../combinedReview/CombinedReviewSlice";
import AssignReasonModal from "../AssignReasonModal/AssignReasonModal";
import { Tooltip, Select,
  MenuItem,
  FormControl, } from "@mui/material";
const STATUS_OPTIONS = [
  "Update status",
  "Flagged For Review",
  "Auditing in Progress",
  "Reviewed, no change",
  "Reviewed, query sent",
  "Reviewed, recoded",
  "Reviewed, query supported, revenue realised"
];

export default function EpisodeReview({
  data,
  onBack,
  loading = false,
  error = null,
  plusFlags,
  auditResults: auditResultsProp,
  onAssign,
  onUnassign,
  onEditAudit,
  onSaveAuditChanges,
  onGenerateCDQ,
  onCancel,
  onCompleteAudit,
  hideUnassign = false,
  onAssignSuccess,
  activeModule,
}) {
  const [status, setStatus] = useState(data?.status || "Update status");
  const [statusUpdating, setStatusUpdating] = useState(false);
  const [editAuditOpen, setEditAuditOpen] = useState(false);
  const dispatch = useDispatch();
  const assignBtnRef = useRef(null);
  const [openAssign, setOpenAssign] = useState(false);
  const [unassignOpen, setUnassignOpen] = useState(false);
  const [unassigning, setUnassigning] = useState(false);
  const handleOpenUnassign = () => setUnassignOpen(true);
  const [iscdqloading, setIscdqloading] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [flagLoading, setFlagLoading] = useState(false);
  const [isFlagged, setIsFlagged] = useState(true);
  const currentUserId = sessionStorage.getItem("userId");
  const { payload } = useSelector((state) => state.codeEnhance);
  const enhancePayload = useSelector((state) => state.codeEnhance.payload);
  const combinedPayload = useSelector((state) => state.combinedReview.payload);
  const [assignReasonOpen, setAssignReasonOpen] = useState(false);
  const [assigning, setAssigning] = useState(false);
  const [pendingAssign, setPendingAssign] = useState(null);
  const [selectedAudit, setSelectedAudit] = useState("");
  const [completeAuditConfirmOpen, setCompleteAuditConfirmOpen] = useState(false);
  const [queryRevenuePopupOpen, setQueryRevenuePopupOpen] = useState(false);
const [expectedRevenueUplift, setExpectedRevenueUplift] = useState("");
  useEffect(() => {
    setStatus(data?.hcp_line_detail?.audit_status || "Update status");
  }, [data?.hcp_line_detail?.audit_status]);

  const hcpLineId = data?.hcp_line_detail?.hcp_line_id;

  const selectedEpisodeForAssign = hcpLineId
    ? [{ hcpLineId, episodeId: data?.hcp_line_detail?.episode_identifier }]
    : [];
  
    const episodeAudited =
  data?.hcp_line_detail?.is_episode_audited || [];

const hasEpisodeAudited =
  Array.isArray(episodeAudited) &&
  episodeAudited.length > 0;

  if (loading) {
    return (
      <div className="ep-page">
        <div className="ep-state">
          <div className="ep-spinner" />
          <p>Loading episode…</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="ep-page">
        <div className="ep-state ep-state-error">
          <p>{error}</p>
          <button className="ep-btn ep-btn-outline" onClick={onBack}>
            Back to list
          </button>
        </div>
      </div>
    );
  }

  if (!data) return null;

  const flags = plusFlags?.data;
  const predictedRevenueUplift =
  Object.values(flags || {})?.[0]?.predicted_reimbursement?.[0] ?? "";

console.log(predictedRevenueUplift, "predictedRevenueUplift");
  const audFormatter = new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const auditRules = (data?.hcp_line_detail?.findings || []).map((item) => ({
    priority: item.priority_value,
    shortDescription: item.audit_rule_short_description,
    longDescription: item.audit_rule_long_description,
    category: item.audit_rule_category,
    refNo: item.audit_rule_ref_no,
    hcpAuditId: item.hcp_audit_id,
  }));

  const auditResults = {
    drg: auditResultsProp?.audit_drg ?? "-",
    nwau: auditResultsProp?.audit_nwau ?? "-",
    amount: auditResultsProp?.audit_revenue ?? "-",
    revenueDiag: auditResultsProp?.revenue_difference ?? "-",
    changes: auditResultsProp?.changes ?? "-",
    date: auditResultsProp?.date ?? "-",
    comments: auditResultsProp?.comment ?? "No comments provided.",
  };
  const NAN_VALUES = new Set(["nan", "null", "", "undefined"]);

  const isEmptyCode = (v) =>
    v == null || NAN_VALUES.has(String(v).trim().toLowerCase());
  const splitCofAndCode = (rawCode) => {
    if (isEmptyCode(rawCode)) return { cof: "", code: "" };
    const value = String(rawCode).trim();
    const firstChar = value.charAt(0);
    if (firstChar === "1" || firstChar === "2") {
      return { cof: firstChar, code: value.slice(1) };
    }
    return { cof: "", code: value };
  };

  const principalCode = data?.hcp_line_detail?.principal_diagnosis?.code;
  const { code: principalCodeWithoutCof } = splitCofAndCode(principalCode);

  const clinicianQuery = `The ARDRG is ${data?.hcp_line_detail?.drg_code}. Generate a CDQ to increase the complexity with diagnosis related to ${principalCodeWithoutCof || "—"}.`;

  const priorityClass = (p) => {
    const v = String(p || "").toLowerCase();
    if (v === "p1" || v.includes("ultra")) return "ep-chip ep-chip-ultra";
    if (v === "p2" || v.includes("high")) return "ep-chip ep-chip-high";
    return "ep-chip ep-chip-default";
  };

  const deltaClass = (v) => {
    const s = String(v || "");
    if (s.startsWith("+")) return "ep-delta ep-delta-pos";
    if (s.startsWith("-")) return "ep-delta ep-delta-neg";
    return "ep-delta";
  };

  const handleCancel = () => {
    onCancel?.();
    onBack?.();
  };

  // const handleComplete = async () => {
  //   const hcpLineId = data?.hcp_line_detail?.hcp_line_id;

  //   if (!hcpLineId) {
  //     toast.error("Missing episode reference (hcp_line_id)");
  //     return;
  //   }

  //   if (status === "Update status") {
  //     toast.error("Please select a status before completing the audit");
  //     return;
  //   }

  //   try {
  //     const res = await dispatch(
  //       updateEpisodeStatus({ hcp_line_id: hcpLineId, status }),
  //     ).unwrap();

  //     toast.success(res?.message || "Status updated successfully");
  //     onCompleteAudit?.();
  //     onBack?.();
  //   } catch (err) {
  //     toast.error(err || "Something went wrong");
  //     // stay on the page — don't call onBack() so the user can retry
  //   }
  // };
  
  const handleComplete = () => {
  const hcpLineId = data?.hcp_line_detail?.hcp_line_id;

  if (!hcpLineId) {
    toast.error("Missing episode reference (hcp_line_id)");
    return;
  }

  if (status === "Update status") {
    toast.error("Please select a status before completing the audit");
    return;
  }

  // Show confirmation popup first
  setCompleteAuditConfirmOpen(true);
};

const handleConfirmCompleteAudit = async () => {
  const hcpLineId = data?.hcp_line_detail?.hcp_line_id;

  if (!hcpLineId) {
    toast.error("Missing episode reference (hcp_line_id)");
    return;
  }

  setCompleteAuditConfirmOpen(false);

  try {
    const res = await dispatch(
      updateEpisodeStatus({
        hcp_line_id: hcpLineId,
        status,
      })
    ).unwrap();

    toast.success(res?.message || "Status updated successfully");

    onCompleteAudit?.();
    onBack?.();
  } catch (err) {
    toast.error(err || "Something went wrong");
  }
};
  const handleOpenEditAudit = () => {
    onEditAudit?.();
    setEditAuditOpen(true);
  };

  const handleCloseEditAudit = () => {
    setEditAuditOpen(false);
  };

  const handleSaveEditAudit = (payload) => {
    onSaveAuditChanges?.(payload);
    // setEditAuditOpen(false);
  };
const handleStatusChange = (e) => {
  const newStatus = e.target.value;

  if (newStatus === "Update status" || newStatus === status) return;

  if (!hcpLineId) {
    toast.error("Missing episode reference (hcp_line_id)");
    return;
  }
  if (newStatus === "Reviewed, query sent") {
    setStatus(newStatus);
    setExpectedRevenueUplift(
      predictedRevenueUplift !== ""
        ? String(predictedRevenueUplift)
        : ""
    );
    setQueryRevenuePopupOpen(true);
    return;
  }

  setStatus(newStatus);
};
  const handleConfirmUnassign = async (reason) => {
    // NEW
    setUnassigning(true);
    try {
      await onUnassign?.(reason);
      setUnassignOpen(false);
    } catch {
      // keep modal open on failure so the user can retry/edit reason
    } finally {
      setUnassigning(false);
    }
  };
  const handleGenerateCDQ = async () => {
    if (!clinicianQuery) return;

    setIscdqloading(true);
    try {
      const response = await axiosInstance.post(
        "/ics_knowledge-base-au-codes-advice",
        { prompt: clinicianQuery },
      );
      const responseData = response.data.body;

      const modalContentData = {
        message: responseData.message,
        location: responseData.location,
        references: responseData.retrievedReferences.map((ref) => ({
          content: ref.content.text,
          location: ref.location.s3Location.uri,
          metadata: ref.metadata["x-amz-bedrock-kb-document-page-number"]
            ? [ref.metadata["x-amz-bedrock-kb-document-page-number"]]
            : [],
        })),
      };

      setModalContent(modalContentData);
    } catch (error) {
      setModalContent({ error: "An error occurred while making the request." });
    } finally {
      setIscdqloading(false);
      setModalVisible(true);
    }
  };
  const handleAssignConfirm = async ({ coder, episodes }) => {
    if (!coder || !episodes.length) return;
    setPendingAssign({ coder, episodes });
    setOpenAssign(false); // close the coder-selection dialog
    setAssignReasonOpen(true); // open the reason modal
  };

  const handleConfirmAssignReason = async (reason) => {
    if (!pendingAssign) return;
    const { coder, episodes } = pendingAssign;

    setAssigning(true);
    try {
      await dispatch(
        assignEpisodes({
          assigned_user_id: coder.user_id,
          assignment_reason: reason,
          assigned_by: Number(currentUserId),
          assignment: true,
          is_flagged: false,
          hcp_lines: episodes.map((item) => item.hcpLineId),
          filter: payload,
        }),
      ).unwrap();

      // toast.success("Episode assigned successfully");
      setAssignReasonOpen(false);
      setPendingAssign(null);

      if (onAssignSuccess) {
        onAssignSuccess();
      } else {
        onBack?.();
      }
    } catch (err) {
      toast.error(err || "Failed to assign episode");
      // keep modal open so the user can retry/edit reason
    } finally {
      setAssigning(false);
    }
  };

  const handleAuditEpisodeClick = async (audit) => {
  const auditHcpLineId = audit?.hcp_line_id;

  if (!auditHcpLineId) {
    toast.error("Missing hcp line id");
    return;
  }

  try {
    await dispatch(
      getEnhanceWorkflowEpisodeDetails(auditHcpLineId)
    ).unwrap();
  } catch (error) {
    console.error("Failed to load episode details:", error);
    toast.error("Failed to load episode details");
  }
};

const formatAuditDate = (dateString) => {
  if (!dateString) return "-";

  const [datePart, timePart] = dateString.split(" ");

  if (!datePart) return dateString;

  const [day, month, year] = datePart.split("-");

  if (!day || !month || !year) {
    return dateString;
  }

  return `${day}/${month}/${year} ${timePart || ""}`.trim();
};

  //   const handleFlagged = async () => {
  //   const payloadData = {
  //     hcp_lines: [hcpLineId], // Current episode
  //     select_all: false,
  //     filter: {
  //       ...payload,
  //       page_number: 1,
  //       is_flagged: false,
  //     },
  //     flag_episode_to: true,
  //   };

  //   try {
  //     await dispatch(recallEpisodes(payloadData)).unwrap();

  //     await dispatch(getCodeEnhanceWorkflowViewData(payload)).unwrap();

  //     toast.success("Episode flagged successfully");
  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Failed to flag episode");
  //   }
  // };

  const handleFlagged = async () => {
    if (!isFlagged || flagLoading) return;

    setFlagLoading(true);
    try {
      const currentPayload =
        activeModule === "Combined Review" ? combinedPayload : enhancePayload;

      const payloadData = {
        hcp_lines: [hcpLineId],
        select_all: false,
        filter: {
          ...currentPayload,
          page_number: 1,
          is_flagged: false,
        },
        flag_episode_to: true,
      };

      if (activeModule === "Combined Review") {
        await dispatch(reflagCombinedReviewEpisodes(payloadData)).unwrap();
        await dispatch(getCombinedReviewData(currentPayload)).unwrap();
      } else {
        await dispatch(recallEpisodes(payloadData)).unwrap();
        await dispatch(getCodeEnhanceWorkflowViewData(currentPayload)).unwrap();
      }

      // Change button only after API success
      setIsFlagged(false);

      toast.success("Episode flagged successfully");
    } catch (err) {
      console.error(err);
      toast.error("Failed to flag episode");
    } finally {
      setFlagLoading(false);
    }
  };
  return (
    <div className="ep-page">
      {/* Single white card — everything lives inside this one panel */}
      <div className="ep-review">
        <div className="ep-page-header">
         <button
           className="ep-back-btn"
            onClick={handleCancel}
            type="button"
            >
              ← Back
            </button>
        <h1 className="ep-title">Episode Review</h1>
         </div>
        {/* Toolbar */}
        <div className="ep-toolbar">
          <div className="ep-toolbar-left">
            <select
              className="ep-select"
              value={status}
              onChange={handleStatusChange}
              disabled={statusUpdating}
            >
              {STATUS_OPTIONS.map((s) => (
                <option key={s} value={s}>
                  {s === "Update status" ? "Status: Update status" : s}
                </option>
              ))}
            </select>
            {/* <button
              className={`flag-toggle-btn ${isFlagged ? "active" : ""}`}
              onClick={handleFlagged}
              disabled={!isFlagged || flagLoading}
            >
              {flagLoading ? (
                <>
                  <span>Flagging...</span>
                  <span className="button-loader"></span>
                </>
              ) : (
                <>
                  <span>
                    {isFlagged ? "Do not flag this episode anymore" : "Flagged"}
                  </span>

                  {isFlagged ? (
                    <CheckCircleIcon className="flag-icon" fontSize="small" />
                  ) : (
                    <FlagIcon className="flag-icon" fontSize="small" />
                  )}
                </>
              )}
            </button> */}
            <button
              ref={assignBtnRef}
              className="ep-btn ep-btn-outline"
              onClick={() => setOpenAssign(true)}
            >
              Assign
            </button>
            {!hideUnassign && (
              <button
                className="ep-btn ep-btn-outline"
                onClick={handleOpenUnassign}
              >
                Unassign
              </button>
            )}
    {hasEpisodeAudited && (
  <FormControl className="episode-audited-dropdown">
    <Select
      value={selectedAudit}
      displayEmpty
      onChange={(e) => {
        setSelectedAudit(e.target.value);
      }}
       renderValue={() => "Previous Episode Audits"}
      MenuProps={{
        PaperProps: {
          className: "episode-audited-menu",
        },
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left",
        },
        getContentAnchorEl: null,
      }}
    >
      {episodeAudited.map((audit, index) => (
        <MenuItem
          key={`${audit?.hcp_line_id}-${index}`}
          value={index}
          className="episode-audited-menu-item"
           disableRipple
        >
          <div className="audit-card">

            {/* Episode ID */}
            <div className="audit-card-row">
              <span className="audit-card-label">
                Episode ID
              </span>

              <button
                type="button"
                className="audit-episode-link"
                onClick={(e) => {
                  e.stopPropagation();
                  handleAuditEpisodeClick(audit);
                }}
              >
                {data?.hcp_line_detail?.episode_identifier || "-"}
              </button>
            </div>

            {/* Status */}
            <div className="audit-card-row">
              <span className="audit-card-label">
                Status
              </span>

              <span className="audit-status-value">
                {audit?.status || "-"}
              </span>
            </div>

            {/* Updated At */}
            <div className="audit-card-row">
              <span className="audit-card-label">
                Audited At
              </span>

              <span className="audit-updated-value">
                {formatAuditDate(audit?.updated_at)}
              </span>
            </div>
            
            {/* principal_diagnosis_code */}
            <div className="audit-card-row">
              <span className="audit-card-label">
                PrincipalDiagnosisCode
              </span>

              <span className="audit-updated-value">
                {formatAuditDate(audit?.principal_diagnosis_code)}
              </span>
            </div>
            <CodesMiniDropdown
  label="Additional Diagnosis"
  codes={audit?.additional_diagnosis_codes}
  isEmptyCode={isEmptyCode}
/>
<CodesMiniDropdown
  label="Procedure Codes"
  codes={audit?.procedure_codes}
  isEmptyCode={isEmptyCode}
/>

             {/* drg_code */}
            <div className="audit-card-row">
              <span className="audit-card-label">
                DrgCode
              </span>

              <span className="audit-updated-value">
                {formatAuditDate(audit?.drg_code)}
              </span>
            </div>

              {/* audit_drg */}
            <div className="audit-card-row">
              <span className="audit-card-label">
                AuditDrg
              </span>

              <span className="audit-updated-value">
                {formatAuditDate(audit?.audit_drg)}
              </span>
            </div>

          </div>
        </MenuItem>
      ))}
    </Select>
  </FormControl>
)}
          </div>
          <button
            className="ep-btn ep-btn-outline ep-icon-btn"
            onClick={handleOpenEditAudit}
          >
            <span className="ep-pencil" aria-hidden>
              ✎
            </span>{" "}
            Edit Audit
          </button>
        </div>

        {/* Episode info — plain bordered row, no separate shadow/radius */}
        <div className="ep-panel ep-info-grid">
          <InfoField
            label="Episode ID"
            value={data?.hcp_line_detail?.episode_identifier}
            link
            onClick={onBack}
          />
          <InfoField
            label="Admission Date"
            value={data?.hcp_line_detail?.admission_date}
          />
          <InfoField
            label="Discharge Date"
            value={data?.hcp_line_detail?.seperation_date}
          />
          <InfoField
            label="LOS"
            value={data?.hcp_line_detail?.length_of_stay}
          />
          <InfoField
            label="Specialty"
            value={
              data?.hcp_line_detail?.speciality ||
              data?.hcp_line_detail?.diagnosis
            }
          />
          <InfoField
            label="Care Type"
            value={data?.hcp_line_detail?.care_type}
          />
          <InfoField
            label="Current DRG"
            value={data?.hcp_line_detail?.drg_code}
          />
          <InfoField
            label="Current NWAU"
            value={data?.hcp_line_detail?.current_NWAU}
          />
          <InfoField
            label="Current $"
            value={data?.hcp_line_detail?.current_drg_revenue}
          />
          <InfoField
            label="Insurer ID"
            value={
              data?.hcp_line_detail?.insurer_identifier ||
              data?.hcp_line_detail?.insurer_id
            }
          />
        </div>
        {completeAuditConfirmOpen && (
  <div
    className="eam-overlay"
    onMouseDown={(e) => {
      if (e.target === e.currentTarget) {
        setCompleteAuditConfirmOpen(false);
      }
    }}
  >
    <div
      className="eam-modal"
      style={{
        maxWidth: 450,
        width: "90%",
      }}
    >
      <div className="eam-header">
        <h2 className="eam-title">Complete Audit</h2>

        <button
          className="eam-close"
          onClick={() => setCompleteAuditConfirmOpen(false)}
        >
          ×
        </button>
      </div>

      <div
        className="eam-body"
        style={{
          textAlign: "center",
          padding: "25px",
        }}
      >
        <p style={{ marginBottom: "25px" }}>
          Do you want to change the status to{" "}
          <strong>{status}</strong>?  
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
          }}
        >
          <button
            className="ep-btn ep-btn-cancel"
            onClick={() => setCompleteAuditConfirmOpen(false)}
          >
            No
          </button>

          <button
            className="ep-btn ep-btn-primary"
            onClick={handleConfirmCompleteAudit}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  </div>
)}

        {/* Enhance Plus Flags */}
      {activeModule !== "Enhance Workflow" && <Section title="Enhance Plus Flags">
          <div className="ep-table-scroll">
            <table className="ep-table">
              <thead>
                <tr>
                  <th>Version</th>
                  <th>Enhance Plus Priority</th>
                  <th>Actual DRG</th>
                  <th>Actual Reimbursement</th>
                  <th>Predicted DRG</th>
                  <th>Predicted Reimbursement</th>
                  <th>Predicted Reimbursement Delta</th>
                </tr>
              </thead>
              <tbody>
                {plusFlags?.status === "LOADING" ? (
                  <tr>
                    <td colSpan={7} className="ep-empty-row">
                      Loading...
                    </td>
                  </tr>
                ) : plusFlags?.status === "FAILURE" ? (
                  <tr>
                    <td colSpan={7} className="ep-empty-row">
                      {plusFlags.error}
                    </td>
                  </tr>
                ) : (
                  Object.entries(flags || {}).map(([version, item]) => (
                    <tr key={version}>
                      <td>{version}</td>
                      <td>
                        <span className={priorityClass(item.pallas_priority)}>
                          {item.pallas_priority}
                        </span>
                      </td>
                      <td>{item.actual_drg}</td>
                      <td>{audFormatter.format(item.actual_reimbursement)}</td>
                      <td>
                        {item.predicted_drg.map((drg) => (
                          <div key={drg}>{drg}</div>
                        ))}
                      </td>
                      <td>
                        {item.predicted_reimbursement.map((value, index) => (
                          <div key={index}>{audFormatter.format(value)}</div>
                        ))}
                      </td>

                      <td>
                        {item.predicted_reimbursement_delta.map(
                          (value, index) => (
                            <div key={index}>{audFormatter.format(value)}</div>
                          ),
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </Section>}

        {/* Audit Rules */}
        {activeModule!=="Enhance Plus Workflow"&&<Section title="Audit Rules">
          <div className="ep-table-scroll">
            <table className="ep-table">
              <thead>
                <tr>
                  <th className="ep-col-narrow">Priority</th>
                  <th>Short Description</th>
                  <th>Long Description</th>
                </tr>
              </thead>
              <tbody>
                {auditRules.length === 0 ? (
                  <tr>
                    <td colSpan={3} className="ep-empty-row">
                      No audit rules flagged
                    </td>
                  </tr>
                ) : (
                  auditRules.map((rule, i) => (
                    <tr key={i}>
                      <td>{rule.priority}</td>
                      <td className="ep-strong">{rule.shortDescription}</td>
                      <td className="ep-muted">
                        {rule.longDescription &&
                        rule.longDescription !== "-" ? (
                          <Tooltip title={rule.longDescription} arrow>
                            <span
                              style={{
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                            >
                              {rule.longDescription}
                            </span>
                          </Tooltip>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </Section>}

        {/* Audit Results */}
        <Section title="Audit Results">
          <div className="ep-table-scroll">
            <table className="ep-table">
              <thead>
                <tr>
                  <th>Audit DRG</th>
                  <th>Audit NWAU</th>
                  <th>Audit $</th>
                  <th>Revenue Difference</th>
                  <th>Changes #</th>
                  <th>Date</th>
                  <th>Comments</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{auditResults.drg}</td>
                  <td>{auditResults.nwau}</td>
                  <td>{auditResults.amount}</td>
                  <td>
                    <span className={deltaClass(auditResults.revenueDiag)}>
                      {auditResults.revenueDiag}
                    </span>
                  </td>
                  <td>{auditResults.changes}</td>
                  <td>{auditResults.date}</td>
                  <td className="ep-muted">{auditResults.comments}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </Section>
        

        {/* Clinician Query */}
        <div className="ep-clinician-block">
          <div className="ep-clinician-label">Clinician Query:</div>
          <div className="ep-clinician-box">
            <p>{clinicianQuery || "No clinician query generated yet."}</p>
            <button
              className="ep-btn ep-btn-accent"
              onClick={handleGenerateCDQ}
              disabled={iscdqloading || !clinicianQuery}
            >
              {iscdqloading ? "Generating..." : "Generate CDQ"}
            </button>
          </div>
        </div>

        {/* Footer actions */}
        <div className="ep-footer-actions">
          <button className="ep-btn ep-btn-cancel" onClick={handleCancel}>
            Cancel
          </button>
          <button className="ep-btn ep-btn-primary" onClick={handleComplete}>
            Complete Audit
          </button>
        </div>
      </div>
      {queryRevenuePopupOpen && (
  <div
    className="eam-overlay"
    onMouseDown={(e) => {
      if (e.target === e.currentTarget) {
        setQueryRevenuePopupOpen(false);
      }
    }}
  >
    <div className="query-revenue-modal">

      <div className="query-revenue-header">
        <h2>Query Sent – Revenue Uplift</h2>

        <button
          type="button"
          className="query-revenue-close"
          onClick={() => setQueryRevenuePopupOpen(false)}
        >
          ×
        </button>
      </div>

      <div className="query-revenue-body">

        <p className="query-revenue-description">
          Please enter the expected revenue uplift from this query before
          continuing.
        </p>

        <label className="query-revenue-label">
          Expected Revenue Uplift <span>*</span>
        </label>

        <div className="query-revenue-input-wrapper">
          <span>$</span>

          <input
            type="text"
             value={expectedRevenueUplift}
            readOnly
            placeholder="No data available"
          />
        </div>

      </div>
    </div>
  </div>
)}

      {/* Edit Audit modal */}
      <EditAuditModal
        isOpen={editAuditOpen}
        data={data}
        onClose={handleCloseEditAudit}
        onSave={handleSaveEditAudit}
        splitCofAndCode={splitCofAndCode}
        isEmptyCode={isEmptyCode}
      />
      <UnassignReasonModal
        isOpen={unassignOpen}
        onClose={() => setUnassignOpen(false)}
        onConfirm={handleConfirmUnassign}
        loading={unassigning}
      />
      <AssignEpisodesDialog
        open={openAssign}
        anchorEl={assignBtnRef.current}
        onClose={() => setOpenAssign(false)}
        selectedEpisodes={selectedEpisodeForAssign}
        onAssign={handleAssignConfirm}
      />
      <AssignReasonModal
        isOpen={assignReasonOpen}
        onClose={() => {
          setAssignReasonOpen(false);
          setPendingAssign(null);
        }}
        onConfirm={handleConfirmAssignReason}
        loading={assigning}
      />
      {modalVisible && (
        <div
          className="eam-overlay"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) setModalVisible(false);
          }}
        >
          <div className="eam-modal" style={{ maxWidth: 640 }}>
            <div className="eam-header">
              <h2 className="eam-title">Clinical Documentation Query</h2>
              <button
                className="eam-close"
                onClick={() => setModalVisible(false)}
              >
                ×
              </button>
            </div>
            <div className="eam-body" style={{ whiteSpace: "pre-line" }}>
              {modalContent?.error ? (
                <p>{modalContent.error}</p>
              ) : (
                <GenerateCDQModal message={{ answer: modalContent }} />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function CodesMiniDropdown({ label, codes,isEmptyCode }) {
  const [open, setOpen] = useState(false);

  const validCodes = (codes || []).filter((c) => !isEmptyCode(c));

  return (
    <div
      className="audit-card-row audit-card-row-list"
      onClick={(e) => e.stopPropagation()}
    >
      <span className="audit-card-label">{label}</span>

      <div className="codes-mini-dropdown">
        <button
          type="button"
          className="codes-mini-trigger"
          onClick={(e) => {
            e.stopPropagation();
            setOpen((prev) => !prev);
          }}
        >
          <span>
            {validCodes.length > 0
              ? `${validCodes.length} code${validCodes.length > 1 ? "s" : ""}`
              : "-"}
          </span>
          {validCodes.length > 0 && (
            <span className={`codes-mini-caret ${open ? "open" : ""}`}>▾</span>
          )}
        </button>

        {open && validCodes.length > 0 && (
          <div
            className="codes-mini-panel"
            onClick={(e) => e.stopPropagation()}
          >
            {validCodes.map((code, i) => (
              <span key={`${code}-${i}`} className="codes-mini-chip">
                {code}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function InfoField({ label, value, link, onClick }) {
  const displayValue =
    value == null || value === "NaN" || value.trim?.().toLowerCase() === "nan"
      ? "—"
      : value;

  return (
    <div className="ep-info-field">
      <div className="ep-info-label">{label}</div>
      {link ? (
        <button className="ep-info-link" onClick={onClick}>
          {displayValue}
        </button>
      ) : (
        <div className="ep-info-value">{displayValue}</div>
      )}
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="ep-section">
      <div className="ep-section-header">{title}</div>
      {children}
    </div>
  );
}
